import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold } from '../../../helpers/getEmailStyles';

class BookingExpiredHost extends Component {
	static propTypes = {
		content: PropTypes.shape({
			guestName: PropTypes.string.isRequired,
			hostName: PropTypes.string.isRequired,
			listTitle: PropTypes.string.isRequired
		}).isRequired
	};

	render() {
		const { content: { hostName, guestName, listTitle, logo, siteName } } = this.props;
		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
				<div style={body}>
					<EmptySpace height={20} />
					<div style={fontWeightBold}>
						Hi {hostName},
					</div>
					<EmptySpace height={20} />
					<div>
						The reservation request from {guestName} for your listing {listTitle} has expired. Since it was not confirmed within the allotted time, it was automatically expired.
					</div>
					<EmptySpace height={20} />
					<EmailSignature siteName={siteName} />
				</div>
				<EmptySpace height={40} />
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}
}

export default BookingExpiredHost;
